import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import EntityIndicatorDialog from '../EntityIndicatorDialog'
import { Divider, Grid2 } from '@mui/material'
import IndicatorHeaderDialog from '../IndicatorHeaderDialog'
import IndicatorTable from '../IndicatorTable'
import { shallowEqual, useSelector } from 'react-redux'
import { getYear } from 'utils/DateUtil'
import { P102_1, VP_129, DC_192, VP_128 } from 'rpqs/constants/RpqsConstant'
import { getIndicatorDialogRow, updateIndicatorEntity, updateManyIndicatorEntity } from 'rpqs/utils/RPQSUtils'
import { round } from 'lodash'

const DialogP102_1 = ({
    open = false,
    setOpen = () => {},
    title = '',
}) => {
    const {
        managementEntity,
    } = useSelector(store => ({
        managementEntity: store.CollectivityReducer.managementEntity,
    }), shallowEqual)

    const [entityDialog, setEntityDialog] = useState(managementEntity)
    const [readMode, setReadMode] = useState(true)

    useEffect(() => {
        setEntityDialog(managementEntity)
    }, [managementEntity])

    const year = getYear(entityDialog?.dateEnd)
    const previousYear = year-1
    const currentEntity = entityDialog?.[year]

    const getIndicatorValue = (indicator) => (currentEntity?.[indicator?.code]?.value || 0)

    useEffect(() => {
        if (!readMode) return

        const newIndicator = { ...currentEntity?.[P102_1.code], value: getIndicatorValue(VP_129) !== 0 ? round((1-getIndicatorValue(VP_128)/getIndicatorValue(VP_129)*100), 2) : 0 }
        const newEntity = updateIndicatorEntity(entityDialog, year, P102_1.code, newIndicator)

        setEntityDialog(newEntity)
    }, [readMode])

    const formatedIndicators = [
        getIndicatorDialogRow({
            readMode,
            entityDialog,
            codeIndicator: P102_1.code,
            indicatorName: i18n[P102_1.i18n],
            unit: '%',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, P102_1.code,
                { ...currentEntity?.[P102_1.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: DC_192.code,
            indicatorName: i18n[DC_192.i18n],
            unit: '%',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, DC_192.code,
                { ...currentEntity?.[DC_192.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_128.code,
            indicatorName: i18n[VP_128.i18n],
            unit: i18n.amount,
            onChange: v => setEntityDialog(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_128.code, value: { ...currentEntity?.[VP_128.code], value: parseInt(v) || 0 } },
                { code: P102_1.code, value: { ...currentEntity?.[P102_1.code], value: (readMode && getIndicatorValue(VP_129) !== 0) ? round((1-parseInt(v)/getIndicatorValue(VP_129)*100), 2) : getIndicatorValue(P102_1) } },
            ]))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_129.code,
            indicatorName: i18n[VP_129.i18n],
            unit: i18n.amount,
            onChange: v => setEntityDialog(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_129.code, value: { ...currentEntity?.[VP_129.code], value: parseInt(v) || 0 } },
                { code: P102_1.code, value: { ...currentEntity?.[P102_1.code], value: (readMode && getIndicatorValue(VP_129) !== 0) ? round((1-getIndicatorValue(VP_128)/parseInt(v)*100), 2) : getIndicatorValue(P102_1) } },
            ]))),
        }),
    ]

    const onStatusChange = (status) => {
        setEntityDialog(updateIndicatorEntity(entityDialog, year, P102_1.code, { ...currentEntity?.[P102_1.code], status }))
    }

    return (
        <EntityIndicatorDialog
            open={open}
            setOpen={setOpen}
            title={title}
            hasNote
            entityDialog={entityDialog}
            setEntityDialog={setEntityDialog}
            codeIndicator={P102_1.code}
            readMode={readMode}
            setReadMode={setReadMode}
        >
            <Grid2 container direction={'column'} gap={2}>
                <IndicatorHeaderDialog
                    current={{
                        year,
                        value: managementEntity?.[year]?.[P102_1.code]?.value,
                    }}
                    previous={{
                        year: previousYear,
                        value: managementEntity?.[previousYear]?.[P102_1.code]?.value,
                    }}
                    status={entityDialog?.[year]?.[P102_1.code]?.status}
                    onStatusChange={onStatusChange}
                    unit={'%'}
                />
                <Divider/>
                <IndicatorTable
                    year={year?.toString()}
                    indicators={formatedIndicators}
                />

            </Grid2>
        </EntityIndicatorDialog>
    )
}

DialogP102_1.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
}

export default DialogP102_1
